import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { UserCircle, Compass } from "lucide-react";
import "./../../../../assets/css/general/Homelayout/MentorshipMatching/MentorshipMatching.css";

const MentorshipMatching = () => {
  const navigate = useNavigate();
  const handleLearnMore = () => {
    navigate("/how-mentorship-works");
  };

  return (
    <section className="mm-mentorship-section">
      <Container className="mm-section-container">
        <Row>
          <Col xs={12}>
            <div className="mm-section-header">
              <h2 className="mm-section-title">Choose your path</h2>
              <p className="mm-section-subtitle">
                Connect with others to learn, grow, and share knowledge
              </p>
            </div>
          </Col>
        </Row>

        <Row className="mm-cards-row">
          <Col xs={12} lg={6} className="mm-card-col">
            <div className="mm-mentorship-card">
              <div className="mm-card-icon-wrapper">
                <UserCircle
                  className="mm-card-icon"
                  size={32}
                  strokeWidth={1.5}
                />
              </div>
              <span className="mm-card-audience">
                For experienced professionals
              </span>
              <h3 className="mm-card-heading">Become a Mentor</h3>
              <p className="mm-card-text">
                Guide learners through their professional journey by sharing
                your experience and expertise in a structured, meaningful way.
                <br />
                All mentors complete a verification process to ensure quality
                guidance.
              </p>
              <button
                onClick={() => navigate("/mentor/application")}
                className="mm-card-button"
              >
                Apply as mentor
              </button>
              <p className="mm-card-reassurance">
                Applications reviewed within 3-5 business days
              </p>
            </div>
          </Col>

          <Col xs={12} lg={6} className="mm-card-col">
            <div className="mm-mentorship-card">
              <div className="mm-card-icon-wrapper">
                <Compass className="mm-card-icon" size={32} strokeWidth={1.5} />
              </div>
              <span className="mm-card-audience">
                For students & early professionals
              </span>
              <h3 className="mm-card-heading">Find a Mentor</h3>
              <p className="mm-card-text">
                Get personalized guidance tailored to your goals, challenges,
                and learning style from experienced professionals.
                <br />
                Browse mentor profiles or let our system match you based on your
                preferences.
              </p>

              <button
                onClick={() => navigate("/mentors")}
                className="mm-card-button mm-card-button-primary"
              >
                Browse mentors
              </button>
              <p className="mm-card-reassurance">
                Update your preferences anytime
              </p>
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <footer className="mm-mentorship-footer">
              <button className="mm-learn-more-link" onClick={handleLearnMore}>
                Not sure yet? Learn how mentorship works
              </button>
            </footer>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default MentorshipMatching;
